import React, { useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { Link } from "react-router-dom";
import Divider from "../Components/Divider";
import CloudCamparision from "../Components/Camparision/CloudComp";
import CurrencyConverter from "../Components/CurrencyConverter";
import { useGeoLocation } from "../utils/useGeoLocation";
import { FaWifi, FaGlobe, FaThemeco } from "react-icons/fa";
import { BsDeviceSsdFill } from "react-icons/bs";
import { GrDomain } from "react-icons/gr";
import { MdEmail } from "react-icons/md";
import { BiSupport } from "react-icons/bi";
import EnhancedSEO from "../Components/EnhancedSEO";
import "../css/cloud-scoped.css";
import { 
  generateMetaTags, 
  pageConfigs, 
  generateServiceSchema,
  generateProductSchema,
  generateFAQSchema
} from "../utils/seoUtils";

function Cloud() {
  const [planselect, setplanselect] = useState("month");
  
  const { 
    userLocation,
    userCurrency 
  } = useGeoLocation();
  
  const monthlyplanHandler = () => {
    setplanselect("month");
  };
  const yearlyplanHandler = () => {
    setplanselect("year");
  };

  // Enhanced SEO configuration
  const cloudPageConfig = generateMetaTags(pageConfigs.cloudHosting);
  
  // Structured data for cloud hosting page
  const cloudStructuredData = [
    generateServiceSchema(
      "Cloud Based Hosting Services",
      "Scalable cloud hosting services in India with high availability, automatic scaling, and enterprise-grade performance for modern businesses."
    ),
    generateProductSchema(
      "Cloud Hosting Plan",
      "Flexible cloud hosting with auto-scaling, high availability, and pay-as-you-grow pricing",
      "199"
    ),
    generateFAQSchema([
      {
        question: "What is cloud hosting?",
        answer: "Cloud hosting uses multiple interconnected servers to host websites, providing better reliability, scalability, and performance compared to traditional single-server hosting."
      },
      {
        question: "How is cloud hosting different from shared hosting?",
        answer: "Cloud hosting offers better scalability, reliability, and performance. Resources can be scaled up or down instantly based on demand, and there's no single point of failure."
      },
      {
        question: "Is cloud hosting suitable for high-traffic websites?",
        answer: "Yes, cloud hosting is perfect for high-traffic websites as it can automatically scale resources during traffic spikes, ensuring consistent performance and uptime."
      }
    ])
  ];

  return (
    <>
      <EnhancedSEO 
        pageConfig={cloudPageConfig}
        structuredData={cloudStructuredData}
      />
      {/* ======= Hero Section =======  */}

      <section
        className="sharedtop bghostingimg"
        id="top"
        style={{ color: "black" }}
      >
        <div className="container">
          <div className="row align-items-center py-md-5">
            <div className="col-lg-8 col-12 cloud-topseccont">
              <div className="container">
                <span className="subhead sa-bluebg-subhead">
                  MANAGED CLOUD HOSTING INDIA
                </span>
                {/* <span className="subhead">👋 Up to 30% off Cloud Hosting</span> */}
                {/* <h1>Unleash the Power of Managed Cloud Hosting</h1> */}
                <h1>Fast & Scalable cloud based Hosting Services</h1>
                {/* <p>
									Get the best-in-class group mentoring plans and professional
									benefits for your team.
								</p> */}
                <p>
                  Enterprice-class cloud platform crafted for amazing speed,
                  superb security and backed by 24x7 managed support. We make
                  Best Cloud Based Hosting Service in India simple and effecient
                  for business that are on mission to achieve exponential
                  growth.
                </p>
                {/* <p className="cloud-topsecstrt">
									Starts at <span>Rs.109/mo</span>
								</p> */}
                <p>
                  <br />
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src="/assets/img/list-arrow.svg"
                      alt="Arrow icon"
                      style={{
                        transform: "rotate(90deg)",
                        margin: "0 0.7rem 0 0",
                      }}
                    ></img>{" "}
                    <span>Free Domain, SSL and Backups </span>
                  </div>
                  <br />
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src="/assets/img/list-arrow.svg"
                      alt="Arrow icon"
                      style={{
                        transform: "rotate(90deg)",
                        margin: "0 0.7rem 0 0",
                      }}
                    ></img>{" "}
                    <span>Free Website Migration & 24/7 support </span>
                  </div>
                </p>
                <br />
                <a href="#pricing" className="btn btn-primary">
                  View Plans
                </a>
                {/* <p className="trustline">
									<span>🛡️</span> TRUSTED AND LOVED BY 100+ TECH FIRST TEAMS
									30 day <span style={{textDecorationLine:"dotted"}}>money-back</span> guarantee
								</p> */}
                <p style={{ margin: "1em 0" }}>
                  7 Day{" "}
                  <span style={{ textDecoration: "dotted underline" }}>
                    money-back
                  </span>{" "}
                  guarantee
                </p>
                <div className="do-referral-badge-container">
                  <div className="do-referral-content">
                    <h4 className="do-referral-heading">Powered by DigitalOcean</h4>
                    <p className="do-referral-text">Our cloud hosting infrastructure is built on DigitalOcean's reliable, high-performance platform for exceptional speed and uptime.</p>
                    <a href="https://www.digitalocean.com/?refcode=5598161eea2d&utm_campaign=Referral_Invite&utm_medium=Referral_Program&utm_source=badge" className="do-referral-link">
                      <img 
                        src="https://web-platforms.sfo2.cdn.digitaloceanspaces.com/WWW/Badge%203.svg" 
                        alt="DigitalOcean Referral Badge" 
                        className="do-referral-badge" 
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 d-none d-lg-block">
              <img
                src="https://res.cloudinary.com/clubhosty/image/upload/v1717116881/cloud-data-transfer_ni9kwc.svg"
                // src="../assets/img/cloud-1.png"
                // src="../img/homebg.webp"
                alt="imges"
                className="img-fluid cloud-hero-img bounce-img"
                // style="filter: hue-rotate(-52deg);"
              />
            </div>
          </div>
        </div>
      </section>
      {/* End Hero  */}
      <main id="main">
        {/* ======= Pricing ======= */}
        <section id="pricing" className="pricing section-bg">
          <div className="container">
            <div className="section-title">
              <h3>Choose a Perfect Plan That's Right For You.</h3>
              <p>
                <span>Shared hosting</span> with the best unlimited features,
                free CDN & fast speed!
              </p>
            </div>

            {/* Location Info Bar */}
            {userLocation && (
              <div style={{
                backgroundColor: '#e3f2fd',
                borderLeft: '4px solid #2196f3',
                padding: '15px 20px',
                margin: '20px 0',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <MdEmail style={{ color: '#2196f3', fontSize: '20px' }} />
                <div>
                  <strong>Your Location:</strong> {userLocation.country || 'Unknown'} 
                  {userLocation.city && `, ${userLocation.city}`}
                  <br />
                  <small style={{ color: '#666' }}>
                    <BiSupport style={{ marginRight: '5px' }} />
                    Pricing shown in {userCurrency} based on your location
                  </small>
                </div>
              </div>
            )}

            <div className="section-title flag"></div>

            <div className="row tabingcustome">
              {/* button start  */}
              <div className="col-12">
                <ul
                  className="nav nav-pills mb-3 justify-content-center"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active first-button"
                      id="pills-inr-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-usa"
                      type="button"
                      role="tab"
                      aria-controls="pills-usa"
                      aria-selected="true"
                    >
                      <img
                        src="./assets/img/usa.jpg"
                        alt=""
                        className="usa-logo"
                      />
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link middle-button"
                      id="pills-usd-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-india "
                      type="button"
                      role="tab"
                      aria-controls="pills-india"
                      aria-selected="false"
                    >
                      <img
                        src="./assets/img/india.jpg"
                        alt=""
                        className="india-logo"
                      />
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link last-button"
                      id="pills-usd-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-singapore"
                      type="button"
                      role="tab"
                      aria-controls="pills-singapore"
                      aria-selected="false"
                    >
                      <img
                        src="./assets/img/singapore.png"
                        alt=""
                        className="singapore-logo"
                      />
                    </button>
                  </li>
                </ul>
              </div>
              {/* button end  */}
            </div>
            <div className="row tabingcustome">
              {/* button start  */}
              <div className="col-12">
                <ul
                  className="nav nav-pills mb-3 justify-content-center"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active first-button"
                      id="pills-inr-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-inr"
                      type="button"
                      role="tab"
                      aria-controls="pills-inr"
                      aria-selected="true"
                      onClick={monthlyplanHandler}
                    >
                      Monthly
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link  last-button"
                      id="pills-inr-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-inr"
                      type="button"
                      role="tab"
                      aria-controls="pills-inr"
                      aria-selected="true"
                      onClick={yearlyplanHandler}
                    >
                      Yearly
                    </button>
                  </li>
                </ul>
              </div>
              {/* button end  */}
            </div>
            <div className="tab-content" id="pills-tabContent">
              {/* usa  */}
              <div
                className="tab-pane fade show active"
                id="pills-usa"
                role="tabpanel"
                aria-labelledby="pills-inr-tab"
              >
                <div className="row">
                  <div className="col-md-4" data-aos-delay="100">
                    {planselect === "month" ? (
                      <>
                        {/* premium#1 monthly usa plan  */}

                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <p>USA PREMIUM#1</p>
                            <p className="subprichead">Ideal For Beginners</p>

                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={179} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / month</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <a
                                href="http://my.clubhosty.com/cart.php?a=add&pid=111&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </a>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi Theme
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 3</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>40GB</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>400 GB</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* premium#1 yearly usa plan  */}
                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <p>USA PREMIUM#1</p>
                            <p className="subprichead">Ideal For Beginners</p>

                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={1799} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / year</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <a
                                href="http://my.clubhosty.com/cart.php?a=add&pid=111&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </a>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi Theme
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 3</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>40GB</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>400 GB</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="col-md-4" data-aos-delay="100">
                    {planselect === "month" ? (
                      <>
                        {/* premium#2 monthly usa plan  */}

                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <span className="advanced">Featured</span>
                            <p>USA PREMIUM#2</p>
                            <p className="subprichead">
                              Perfect For Professionals
                            </p>

                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={229} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / month</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <Link
                                to="http://my.clubhosty.com/cart.php?a=add&pid=112&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </Link>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi Theme
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 5</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>Unlimited</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>Unlimited</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* premium#2 yearly usa plan  */}

                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <span className="advanced">Featured</span>
                            <p>USA PREMIUM#2</p>
                            <p className="subprichead">
                              Perfect For Professionals
                            </p>

                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={2299} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / year</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <Link
                                to="http://my.clubhosty.com/cart.php?a=add&pid=112&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </Link>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi Theme
                            </li>

                            <li>
                              <span>
                                <GrDomain />
                              </span>
                              <b>1 Free</b> Domain
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 5</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>Unlimited</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>Unlimited</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="col-md-4" data-aos-delay="100">
                    {/* premium#3 monthly usa plan  */}
                    {planselect === "month" ? (
                      <>
                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <p>USA PREMIUM#3</p>
                            <p className="subprichead">
                              Optimized For Businesses
                            </p>

                            {/* <h4><sup>₹</sup>189<span> / month</span></h4>  */}
                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={359} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / month</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <Link
                                to="http://my.clubhosty.com/cart.php?a=add&pid=113&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </Link>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi Theme
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 7</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>Unlimited</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>Unlimited</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* premium#3 usa yearly plan */}
                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <p>USA PREMIUM#3</p>
                            <p className="subprichead">
                              Optimized For Businesses
                            </p>

                            {/* <h4><sup>₹</sup>189<span> / month</span></h4>  */}
                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={3599} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / year</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <Link
                                to="http://my.clubhosty.com/cart.php?a=add&pid=113&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </Link>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi & Elementor Pro
                            </li>

                            <li>
                              <span>
                                <GrDomain />
                              </span>
                              <b>1 Free</b> Domain
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 7</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>Unlimited</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>Unlimited</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              {/* india  */}
              <div
                className="tab-pane fade show "
                id="pills-india"
                role="tabpanel"
                aria-labelledby="pills-inr-tab"
              >
                <div className="row">
                  <div className="col-md-4" data-aos-delay="100">
                    {planselect === "month" ? (
                      <>
                        {/* premium#1 monthly india plan  */}

                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <p>IND PREMIUM#1</p>
                            <p className="subprichead">Ideal For Beginners</p>

                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={179} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / month</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <a
                                href="http://my.clubhosty.com/cart.php?a=add&pid=99&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </a>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi Theme
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 3</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>40GB</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>400 GB</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* premium#1 yearly indai plan  */}
                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <p>IND PREMIUM#1</p>
                            <p className="subprichead">Ideal For Beginners</p>

                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={1799} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / year</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <a
                                href="http://my.clubhosty.com/cart.php?a=add&pid=99&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </a>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi Theme
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 3</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>40GB</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>400 GB</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="col-md-4" data-aos-delay="100">
                    {planselect === "month" ? (
                      <>
                        {/* premium#2 monthly india plan  */}

                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <span className="advanced">Featured</span>
                            <p>IND PREMIUM#2</p>
                            <p className="subprichead">
                              Perfect For Professionals
                            </p>

                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={229} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / month</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <Link
                                to="http://my.clubhosty.com/cart.php?a=add&pid=100&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </Link>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi Theme
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 5</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>Unlimited</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>Unlimited</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* premium#2 yearly india plan  */}

                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <span className="advanced">Featured</span>
                            <p>IND PREMIUM#2</p>
                            <p className="subprichead">
                              Perfect For Professionals
                            </p>

                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={2299} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / year</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <Link
                                to="http://my.clubhosty.com/cart.php?a=add&pid=100&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </Link>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi Theme
                            </li>

                            <li>
                              <span>
                                <GrDomain />
                              </span>
                              <b>1 Free</b> Domain
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 5</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>Unlimited</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>Unlimited</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="col-md-4" data-aos-delay="100">
                    {/* premium#3 monthly india plan  */}
                    {planselect === "month" ? (
                      <>
                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <p>IND PREMIUM#3</p>
                            <p className="subprichead">
                              Optimized For Businesses
                            </p>

                            {/* <h4><sup>₹</sup>189<span> / month</span></h4>  */}
                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={359} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / month</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <Link
                                to="http://my.clubhosty.com/cart.php?a=add&pid=101&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </Link>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi Theme
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 7</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>Unlimited</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>Unlimited</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* premium#3 india yearly plan */}
                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <p>IND PREMIUM#3</p>
                            <p className="subprichead">
                              Optimized For Businesses
                            </p>

                            {/* <h4><sup>₹</sup>189<span> / month</span></h4>  */}
                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={3599} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / year</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <Link
                                to="http://my.clubhosty.com/cart.php?a=add&pid=101&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </Link>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi & Elementor Pro
                            </li>

                            <li>
                              <span>
                                <GrDomain />
                              </span>
                              <b>1 Free</b> Domain
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 7</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>Unlimited</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>Unlimited</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              {/* singapore  */}
              <div
                className="tab-pane fade show "
                id="pills-singapore"
                role="tabpanel"
                aria-labelledby="pills-inr-tab"
              >
                <div className="row">
                  <div className="col-md-4" data-aos-delay="100">
                    {planselect === "month" ? (
                      <>
                        {/* premium#1 monthly singapore plan  */}

                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <p>SG PREMIUM#1</p>
                            <p className="subprichead">Ideal For Beginners</p>

                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={179} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / month</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <a
                                href="http://my.clubhosty.com/cart.php?a=add&pid=108&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </a>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi Theme
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 3</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>40GB</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>400 GB</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* premium#1 yearly singapore plan  */}
                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <p>SG PREMIUM#1</p>
                            <p className="subprichead">Ideal For Beginners</p>

                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={1799} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / year</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <a
                                href="http://my.clubhosty.com/cart.php?a=add&pid=108&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </a>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi Theme
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 3</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>40GB</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>400 GB</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="col-md-4" data-aos-delay="100">
                    {planselect === "month" ? (
                      <>
                        {/* premium#2 monthly singapore plan  */}

                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <span className="advanced">Featured</span>
                            <p>SG PREMIUM#2</p>
                            <p className="subprichead">
                              Perfect For Professionals
                            </p>

                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={229} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / month</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <Link
                                to="http://my.clubhosty.com/cart.php?a=add&pid=109&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </Link>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi Theme
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 5</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>Unlimited</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>Unlimited</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* premium#2 yearly singapore plan  */}

                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <span className="advanced">Featured</span>
                            <p>SG PREMIUM#2</p>
                            <p className="subprichead">
                              Perfect For Professionals
                            </p>

                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={2299} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / year</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <Link
                                to="http://my.clubhosty.com/cart.php?a=add&pid=109&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </Link>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi Theme
                            </li>

                            <li>
                              <span>
                                <GrDomain />
                              </span>
                              <b>1 Free</b> Domain
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 5</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>Unlimited</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>Unlimited</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="col-md-4" data-aos-delay="100">
                    {/* premium#3 monthly singapore plan  */}
                    {planselect === "month" ? (
                      <>
                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <p>SG PREMIUM#3</p>
                            <p className="subprichead">
                              Optimized For Businesses
                            </p>

                            {/* <h4><sup>₹</sup>189<span> / month</span></h4>  */}
                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={359} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / month</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <Link
                                to="http://my.clubhosty.com/cart.php?a=add&pid=110&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </Link>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi Theme
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 7</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>Unlimited</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>Unlimited</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* premium#3 singapore yearly plan */}
                        <div className="box sharedbox">
                          <div className="pricing-head">
                            <p>SG PREMIUM#3</p>
                            <p className="subprichead">
                              Optimized For Businesses
                            </p>

                            {/* <h4><sup>₹</sup>189<span> / month</span></h4>  */}
                            <h4 style={{
                              background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                              color: '#fff',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              margin: '15px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              border: 'none',
                              boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                            }}>
                              <CurrencyConverter priceINR={3599} />
                              <span style={{ fontSize: '16px', opacity: '0.9' }}> / year</span>
                            </h4>

                            <div className="btn-wrap mt-3">
                              <Link
                                to="http://my.clubhosty.com/cart.php?a=add&pid=110&billingcycle=monthly"
                                className="btn-buy"
                              >
                                Buy Now
                              </Link>
                            </div>
                          </div>
                          <ul>
                            <li>
                              <span>
                                <FaThemeco />
                              </span>
                              <b style={{ color: "red" }}>Free</b> Astra Pro &
                              Divi & Elementor Pro
                            </li>

                            <li>
                              <span>
                                <GrDomain />
                              </span>
                              <b>1 Free</b> Domain
                            </li>

                            <li>
                              <span>
                                <FaGlobe />
                              </span>
                              <b>Host 7</b> Website
                            </li>

                            <li>
                              <span>
                                <BsDeviceSsdFill />
                              </span>
                              <b>Unlimited</b> NVME SSD
                            </li>

                            <li>
                              <span>
                                <FaWifi />
                              </span>
                              <b>Unlimited</b> Bandwidth
                            </li>
                          </ul>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ======= End Pricing =======  */}
        <CloudCamparision />
        {/* ======= Services Section =======  */}
        <section className="services cloud-services" id="services">
          <div className="container">
            <div className="section-title">
              <h2>More Power. Faster. Dedicated.</h2>
              <h3>
                Simplicity <span>Meets</span> Performance
              </h3>
            </div>
            <div className="row">
              <div className="col-md-4" data-aos-delay="100">
                <div className="icon-box shbx">
                  <div className="icon">
                    <i className="bx bxl-dribbble"></i>
                  </div>
                  <h4>
                    <Link to="">Simplicity That Saves Time</Link>
                  </h4>
                  <p>
                    Staging environment, managing backups, vertical scaling, or
                    installing free SSL; every operation is a few clicks away,
                    allowing you to get more work done in less time.
                  </p>
                </div>
              </div>
              <div className="col-md-4" data-aos-delay="200">
                <div className="icon-box shbx">
                  <div className="icon">
                    <i className="bx bx-file"></i>
                  </div>
                  <h4>
                    <Link to="">Performance Without Bounds</Link>
                  </h4>
                  <p>
                    A fully optimized stack with built-in advanced cache and
                    Cloudflare (CDN), ensures peak website performance,
                    resulting in faster growth and less frustration.
                  </p>
                </div>
              </div>
              <div className="col-md-4" data-aos-delay="300">
                <div className="icon-box shbx">
                  <div className="icon">
                    <i className="bx bx-tachometer"></i>
                  </div>
                  <h4>
                    <Link to="">Flexibility That Adapts</Link>
                  </h4>
                  <p>
                    Choice of 3 cloud providers (DigitalOcean, GCE, AWS, etc.)
                    to unlimited websites (WordPress, PHP, etc.) on any plan
                    gives you freedom and control over your vision.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Services Section  */}
        <section
          id="featured-services"
          className="featured-services section-bg"
          style={{ padding: "60px 0px" }}
        >
          <div className="container">
            <div className="section-title" style={{ textAlign: "center", marginBottom: "4px" }}>
              <h2>Why Choose ClubHosty?</h2>
              <p><strong>CLOUD HOSTING BUNDLED WITH EXCEPTIONAL FEATURES</strong></p>
              <p style={{ textAlign: 'center' }}>Embrace the agility of cloud hosting features, where flexibility meets performance to fuel your digital innovation.</p>
            </div>
            <div className="row g-4">
              <div className="col-lg-4 col-md-6">
                <div className="icon-box digitalocean-feature" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)",
                  borderLeft: "3px solid #21bcc3"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://web-platforms.sfo2.cdn.digitaloceanspaces.com/WWW/Badge%203.svg"
                      alt="DigitalOcean Infrastructure"
                      style={{ width: "45px", height: "45px" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">Powered by DigitalOcean Infrastructure</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Our cloud hosting services are built on DigitalOcean's world-class infrastructure, providing enterprise-grade SSD performance, 99.99% uptime reliability, and global data center presence for optimal speed and redundancy.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713847753/ultimate-speed_xvvdzc.png"
                      alt="Ultimate Speed"
                      style={{ width: "35px", height: "35px", filter: "hue-rotate(317deg) saturate(1.2)" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">Ultimate 10x Speed Boost</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Host eCommerce store, digital agency or online business on our industry-leading hardware, high-performance CPUs, and DDR4 RAM. Attain blazing-fast performance with the best-in-class IT infrastructure for your website.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713847815/managed-cloud_cszpor.png"
                      alt="Managed Cloud"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">Managed Cloud Hosting Platform</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Offload your technical concerns like server setup, performance issues, and software installation by choosing our managed cloud hosting services backed by 24x7 technical assistance.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713847859/user-friendly-panel_ebajgb.png"
                      alt="User-Friendly Panel"
                      style={{ width: "35px", height: "35px", filter: "hue-rotate(317deg) saturate(1.2)" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">User-Friendly Control Panel</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Our user-friendly control panel dispels technical complexities, transforming cloud management into a seamless task. Whether you're a seasoned IT pro or a complete novice, our control panel empowers you to take control of your cloud environment.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713847899/security-backups_aws7kd.png"
                      alt="Security & Backups"
                      style={{ width: "35px", height: "35px", filter: "hue-rotate(317deg) saturate(1.2)" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">Enterprise-Grade Security & Backups</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Safely store your data in our unwavering cloud hosting infrastructure. We deploy automated backups to safeguard your valuable files and databases, ensuring their integrity and availability.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713847939/affordabillity-performance_nqc2mc.png"
                      alt="Affordability & Performance"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">Affordability Meets Performance</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Experience the perfect blend of affordability & performance. ClubHosty's cloud hosting is the key to enhancing your online presence, providing the necessary resources for growth without a hefty price tag.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ======= Shared Benifits =======  */}
        <section className="cloud-shared-benifits">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div>
                  <h2>Get Higher ROI From Your Websites</h2>
                  <p>
                    With Clubhosty, your websites are faster, more secure, and
                    backed by 24/7 <br />
                    real-time expert support.
                  </p>
                  <Link to="" className="btn btn-primary">
                    Check Plans
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Shared Bentfits  */}
        {/* ======= About Section =======  */}
        <section 
          className="cloudabout section-bg" 
          id="about"
          style={{ 
            backgroundColor: "#ffffff", 
            padding: "80px 0",
            position: "relative",
            overflow: "hidden"
          }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6" data-aos-delay="100">
                <div style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(33, 188, 195, 0.1)",
                  position: "relative",
                  height: "100%"
                }}>
                  <img
                    src="https://res.cloudinary.com/clubhosty/image/upload/v1713573874/storyline-ai-chatbot-robot-ai-service_skzucw.svg"
                    alt="24/7 Expert Support"
                    style={{ 
                      width: "100%",
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "15px",
                      filter: "hue-rotate(336deg) saturate(1.2)"
                    }}
                  />
                </div>
              </div>
              
              <div className="col-lg-6" data-aos-delay="200">
                <div style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(33, 188, 195, 0.1)",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center"
                }}>
                  <h2 style={{ 
                    color: "#333", 
                    fontSize: "36px", 
                    fontWeight: "600", 
                    lineHeight: "1.2", 
                    marginBottom: "20px",
                    fontFamily: "'Poppins', sans-serif"
                  }}>
                    Save Time With <span style={{ color: "#21bcc3" }}>24/7 Expert</span> Support
                  </h2>
                  
                  <p style={{ 
                    color: "#666", 
                    fontSize: "16px", 
                    lineHeight: "1.6", 
                    marginBottom: "30px",
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: "500"
                  }}>
                    You get 24/7/365 expert support for solving problems on the spot. And if you need a closer partnership, you can choose the Advanced Support add-on for enhanced support or the Premium Support add-on, which gives you access to our Senior Support Engineers, who act as an extension of your in-house team.
                  </p>
                  
                  <button 
                    onClick={() => {
                      const pricingSection = document.getElementById('pricing');
                      if (pricingSection) {
                        pricingSection.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                    style={{ 
                      background: "#21bcc3",
                      border: "none",
                      color: "#fff",
                      padding: "15px 30px",
                      fontSize: "16px",
                      fontWeight: "600",
                      borderRadius: "8px",
                      cursor: "pointer",
                      boxShadow: "0 4px 15px rgba(33, 188, 195, 0.3)",
                      transition: "all 0.3s ease",
                      fontFamily: "'Poppins', sans-serif",
                      alignSelf: "flex-start"
                    }}>
                    Check Plans
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <style jsx>{`
            .cloudabout button:hover {
              transform: translateY(-2px);
              background: #20bfc0;
              box-shadow: 0 6px 20px rgba(33, 188, 195, 0.4);
            }
          `}</style>
        </section>
        {/* End About Section  */}
        {/* FAQ START  */}
        <section id="about" className="about">
          <div className="section-title">
            <h2>Frequently Asked Questions</h2> <Divider />
            {/* <p style={{padding:"10px"}}>
						You ask, we answer! Here are the most asked questions for our Domain
						Registration service!
					</p> */}
          </div>
          <div className="accordionContainer">
            <Accordion allowZeroExpanded>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What is Cloud Hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Basically,cloud hosting is the combination of full power and
                    reliability of a VPS with the simplicity of a shared hosting
                    platform to create an optimized hosting environment. On the
                    contrary to traditional hosting, cloud hosting uses an
                    interconnected network of servers to deliver higher
                    availability, security and faster performance to websites
                    and applications.
                  </p>
                  <p>
                    It’s perhaps the best solution for small to large-scale
                    businesses looking to take their online presence to the next
                    level.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    When is the right time to opt for cloud hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Cloud hosting is apt for a range of business needs. If you
                    have a website that needs super-fast performance and speed,
                    here: say, you have a high-traffic, or a large website, or a
                    fully-blown eCommerce store, cloud hosting works the best.
                    You can enjoy blazing-fast speed, high-class security and
                    everything you need for a smooth cloud journey.
                  </p>
                  <p>
                    Cloud servers offer excellent scalability and security,
                    guaranteeing that your site remains unaffected by traffic
                    spikes or suspicious activities from other sites. In short,
                    opting for cloud hosting in India can help your website and
                    overall business succeed online.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What are the key benefits of cloud hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    With cloud hosting, you’ve got covered with a range of
                    benefits:
                  </p>
                  <p>
                    <b>Fully Managed:</b> You can spend time focusing on your
                    business while we take care of the server management,
                    monitoring and more for you.
                  </p>
                  <p>
                    <b>Enjoy Simplicity:</b> You can easily manage your cloud
                    server with the powerful control panel included with our
                    cloud web hosting plans.
                  </p>
                  <p>
                    <b>Premium Features:</b> We include all the premium features
                    like, SSL, domain name, backups, LiteSpeed + LSCache, CDN
                    and 24/7 expert support.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    How is the infrastructure of ClubHosty’s cloud hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Being one of the top cloud hosting provider in India, we use
                    CloudLinux with LVE containers combined with the industry’s
                    latest technology. The functioning is such that each account
                    gets a dedicated container and is served from there.
                  </p>
                  <p>
                    The benefit of cloud computing technology is, every
                    container has a resource limit to ensure your website
                    remains up and running online 24/7, even if any of the
                    accounts on the server is affected by a breach or attack.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Do you offer a control panel with cloud hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes! We offer a powerful cPanel control panel to make your
                    cloud management a breeze. Through a single, user-friendly
                    dashboard, you can manage your websites, emails, databases,
                    install softwares and more with ease. We aim to make managed
                    cloud hosting services simple and efficient for you!
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Which storage do you use for cloud server hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    We utilize SSD NVMe storage with our Best Cloud Based
                    Hosting Service plans. This way, you get faster loading
                    times, performance and reliability for your website or
                    application.
                  </p>
                  <p>
                    You can experience an instant performance boost with our
                    100% SSD-NVMe based cloud servers, CDN, LiteSpeed + LSCache
                    and more.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </section>
      </main>
    </>
  );
}

export default Cloud;
